var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path11, _ellipse5, _path12, _path13, _ellipse6, _path14, _path15, _ellipse7, _path16, _ellipse8, _path17, _ellipse9, _rect2, _rect3, _ellipse0, _ellipse1, _ellipse10, _rect4, _g, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 800",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "amb",
    cx: "52%",
    cy: "68%",
    r: "42%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e07810",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#b85a08",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#7a2e0a",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#1a1028",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c0818",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ambCeil",
    cx: "52%",
    cy: "64%",
    r: "30%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d06808",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#8a3808",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c0818",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#0a0e1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#0e1428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080c18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "floor",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1428",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060810",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "haze",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a2838",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1a2838",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0e1820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow6",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow14",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow30",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft3",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,180 Q200,240 400,200 Q600,160 800,210 Q1000,250 1200,180 L1200,0Z",
    fill: "#06080e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,130 Q150,180 300,155 Q500,120 700,165 Q900,195 1100,145 L1200,130 L1200,0Z",
    fill: "#070a12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240,0 L230,95 Q240,110 250,95 L255,0Z",
    fill: "#050810",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480,0 L472,75 Q480,88 488,75 L495,0Z",
    fill: "#050810",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M720,0 L713,60 Q720,72 727,60 L733,0Z",
    fill: "#050810",
    fillOpacity: 0.65
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M960,0 L954,80 Q960,92 967,80 L972,0Z",
    fill: "#050810",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L115,50 Q120,60 126,50 L130,0Z",
    fill: "#050810",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M840,0 L834,65 Q840,76 846,65 L851,0Z",
    fill: "#050810",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,800 L200,800 L220,650 Q200,580 180,500 Q160,420 170,340 Q180,260 160,180 Q140,110 120,50 L80,0Z",
    fill: "#040610",
    fillOpacity: 0.85
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1200,0 L1200,800 L1000,800 L980,640 Q1000,560 1020,475 Q1040,390 1030,305 Q1020,225 1040,145 Q1060,75 1080,30 L1120,0Z",
    fill: "#040610",
    fillOpacity: 0.8
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M380,800 L380,500 Q380,400 450,360 Q520,320 600,315 Q680,310 750,355 Q820,400 820,500 L820,800Z",
    fill: "#080c18",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M420,800 L420,510 Q420,430 480,395 Q540,360 600,358 Q660,356 720,390 Q780,425 780,510 L780,800Z",
    fill: "#0a0e1e",
    fillOpacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 540,
    rx: 120,
    ry: 180,
    fill: "url(#amb)",
    filter: "url(#glow30)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 540,
    rx: 60,
    ry: 90,
    fill: "url(#amb)",
    filter: "url(#glow14)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 672,
    rx: 45,
    ry: 12,
    fill: "#e07810",
    fillOpacity: 0.35,
    filter: "url(#glow14)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 665,
    rx: 22,
    ry: 8,
    fill: "#f09020",
    fillOpacity: 0.55,
    filter: "url(#glow6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M588,668 L592,700 L600,705 L608,700 L612,668Z",
    fill: "#1a0e08",
    fillOpacity: 0.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 705,
    rx: 14,
    ry: 5,
    fill: "#140c06",
    fillOpacity: 0.85
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M596,644 Q598,630 600,620 Q602,630 604,644Z",
    fill: "#f09020",
    fillOpacity: 0.7,
    filter: "url(#soft3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M598,648 Q600,636 602,648Z",
    fill: "#fdb040",
    fillOpacity: 0.8,
    filter: "url(#soft3)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 80,
    rx: 280,
    ry: 120,
    fill: "url(#ambCeil)",
    filter: "url(#glow30)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0,750 Q300,710 600,720 Q900,730 1200,750 L1200,800 L0,800Z",
    fill: "url(#floor)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0,780 Q300,755 600,762 Q900,768 1200,780 L1200,800 L0,800Z",
    fill: "#050710",
    fillOpacity: 0.7
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 775,
    rx: 180,
    ry: 30,
    fill: "#c06010",
    fillOpacity: 0.14,
    filter: "url(#glow14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290,800 L282,300 Q285,280 290,275 Q295,270 300,275 Q308,280 310,300 L318,800Z",
    fill: "#060a14",
    fillOpacity: 0.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 280,
    rx: 20,
    ry: 10,
    fill: "#07090f",
    fillOpacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M882,800 L874,300 Q877,280 882,275 Q887,270 892,275 Q900,280 902,300 L910,800Z",
    fill: "#060a14",
    fillOpacity: 0.8
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 892,
    cy: 280,
    rx: 20,
    ry: 10,
    fill: "#07090f",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 350,
    width: 18,
    height: 200,
    fill: "#c06010",
    fillOpacity: 0.06,
    filter: "url(#glow6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 882,
    y: 350,
    width: 18,
    height: 200,
    fill: "#c06010",
    fillOpacity: 0.06,
    filter: "url(#glow6)"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 480,
    rx: 320,
    ry: 45,
    fill: "#1e3840",
    fillOpacity: 0.3,
    filter: "url(#glow14)"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 950,
    cy: 510,
    rx: 280,
    ry: 38,
    fill: "#1a3440",
    fillOpacity: 0.25,
    filter: "url(#glow14)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 580,
    rx: 350,
    ry: 28,
    fill: "#1a2e38",
    fillOpacity: 0.18,
    filter: "url(#glow14)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 350,
    width: 1200,
    height: 200,
    fill: "url(#haze)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0a030",
    fillOpacity: 0.55,
    filter: "url(#soft3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 630,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 615,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 600,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622,
    cy: 595,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 580,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 572,
    r: 1
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 800,
    fill: "#020408",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 0,
    width: 160,
    height: 800,
    fill: "#020408",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 60,
    fill: "#030508",
    fillOpacity: 0.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 740,
    width: 1200,
    height: 60,
    fill: "#020408",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.217562ada1edf61c143de3184ac26727.svg";
export { ForwardRef as ReactComponent };